import { render, staticRenderFns } from "./PaxelBig.vue?vue&type=template&id=489d3f2c&"
import script from "./PaxelBig.vue?vue&type=script&lang=js&"
export * from "./PaxelBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports